import { Component, OnInit } from '@angular/core';
import { GameService } from '../../services/game.service';
import { StorageKey, StorageService } from '../../services/storage.service';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    standalone: false
})
export class DatePickerComponent implements OnInit {
  startDate: Date;
  endDate: Date;

  constructor(
    public gameService: GameService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    if (!this.storageService.has(StorageKey.START_DATE)) {
      this.gameService.setStartDateOrEndDate(new Date(), null);
    }
    this.gameService.determineDayDifferenceFromStartDate();
    this.gameService.setTrainWidthBasedOnDateDifference();
    this.gameService.setBackgroundBasedOnDate();
    this.gameService.buildDateRange();
  }

  hideDatePicker() {
    this.gameService.showDatePicker = false;
    this.gameService.showEndDatePicker.next(false);
    this.storageService.set(StorageKey.INTRODUCTION, false);
  }
}
